import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { ColumnModelItemEntity } from './column-model-item.entity';

export interface ISubscriptionColumnModelListExtra
	extends IListColumnConfig<ColumnModelItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
}

interface ISubscriptionColumnModelListEntity
	extends IListAttrs<ColumnModelItemEntity> {
	availableColumns: Map<string, ISubscriptionColumnModelListExtra>;
}

const entityDefaults: ISubscriptionColumnModelListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class ColumnModelListEntity
	implements
		ISubscriptionColumnModelListEntity,
		IListOperations<ColumnModelListEntity, ColumnModelItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<ISubscriptionColumnModelListExtra>
	): ColumnModelListEntity {
		const inst = new ColumnModelListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, ISubscriptionColumnModelListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<ColumnModelItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, ColumnModelItemEntity>
	): ColumnModelListEntity {
		return produce(this, (draft: ColumnModelListEntity) => {
			draft.elements = elems;
		});
	}
}
